/* src/modules/students/actions.js */

import {
  fetchStudentsTypes,
  fetchStudentTypes,
  addCreditsTypes,
  removeStudentTypes,
  CLEAR_SELECTED_STUDENT,
} from './action_types';

import {
  FETCH_STUDENTS_QUERY,
  FETCH_STUDENT_QUERY,
  ADD_CREDITS_MUTATION,
  REMOVE_STUDENT_MUTATION,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const fetchStudents = variables => makeQuery(variables)(
  fetchStudentsTypes,
  FETCH_STUDENTS_QUERY
);

export const fetchStudent = variables => makeQuery(variables)(
  fetchStudentTypes,
  FETCH_STUDENT_QUERY
);

export const addCredits = variables => makeMutation({ variables })(
  addCreditsTypes,
  ADD_CREDITS_MUTATION
);

export const removeStudent = variables => makeMutation({ variables })(
  removeStudentTypes,
  REMOVE_STUDENT_MUTATION
);

export const clearSelectedStudent = () => ({
  type: CLEAR_SELECTED_STUDENT,
});



// WEBPACK FOOTER //
// ./src/modules/students/actions.js